class LightGallery {
	constructor() {
		this.page = document.querySelector(".page-qui-sommes-nous");
		if (!this.page) {
			return;
		}

		this.buildLightGallery();
	}

	buildLightGallery() {
		lightGallery(document.querySelector('.block-rich-text-1'), {
			speed: 500,
			selector: "a",
			zoomFromOrigin: true,
			licenseKey: '0000-0000-000-0001',
			actualSizeIcons: {
				zoomIn: 'lg-zoom-in',
				zoomOut: 'lg-zoom-out'
			}
		});
	}
}